import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useReturnToPermit = (
  isLoading,
  isStartAssessment,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isApplicationStatusAllowed =
    ['FOR LICENSE ASSESSMENT'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isApplicationStatusAllowed;

  const showComponent = isAllowed && isStartAssessment;

  const onHandleClick = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to return this application to Permit Assessor?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-danger font-weight-bold"
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Return to Permit
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useReturnToPermit;
